import { Component, Injector, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseComponent, JkcheckboxComponent, JkComboboxComponent, JkdaterangeComponent, TitlebarComponent, } from 'jk-service';
import { RowClickedEvent } from 'ag-grid-community';
import { MaterialModule } from 'jk-service';
import { JkBaseOption } from 'jk-service';
import { idNameItem, } from 'jk-service';
import { jkLib } from 'jk-service';
import { jkQueryComponent } from 'jk-advcom';
import { JkrangeComponent, JkmultiselectComponent, JkgridwinComponent } from 'jk-advcom';


class Taxpq80Option extends JkBaseOption {
  date1: string = '';
  date2: string = '';
  createDate1: string = '';
  createDate2: string = '';
  month1: string = '';
  month2: string = '';
  taxno1: string = '';
  taxno2: string = '';
  status: idNameItem[] = [];
  msWC001: idNameItem[] = [];
  msWC005: idNameItem[] = [];
  msWC006: idNameItem[] = [];
  notConfirm: boolean = false;

  constructor(programId: string) {
    super(programId);
  }
  override init() {
    super.init();
  }
}


@Component({
  selector: 'app-taxpq80',
  standalone: true,
  imports: [MaterialModule, JkComboboxComponent, TitlebarComponent,
    JkdaterangeComponent, JkcheckboxComponent, JkrangeComponent, JkmultiselectComponent, JkgridwinComponent,
  ],
  templateUrl: './taxpq80.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './taxpq80.component.css'
})
export class Taxpq80Component extends jkQueryComponent {
  override _programId = 'taxpq80'; // ###
  filterOpt: Taxpq80Option = new Taxpq80Option(this.programId); //###
  /*@ViewChild('rgWC003Com') rgWC003!: JkrangeComponent;
  @ViewChild('rgWC004Com') rgWC004!: JkdaterangeComponent;
  @ViewChild('rgCreateDateCom') rgCreateDate!: JkdaterangeComponent;
  @ViewChild('rgWC001Com') rgWC001!: JkrangeComponent;
  @ViewChild('msWC001Com.Com') msWC001Com.!: JkmultiselectComponent;
  @ViewChild('msStatusCom') msStatus!: JkmultiselectComponent;
  @ViewChild('notConfirmCom') notConfirm!: JkcheckboxComponent;
  @ViewChild('msWC006Com') msWC006!: JkmultiselectComponent;
  @ViewChild('msWC005Com') msWC005!: JkmultiselectComponent;
  @ViewChild('kindCom') cboKind!: JkComboboxComponent;
  */
  rgWC003Com!: JkrangeComponent;
  rgWC004Com!: JkdaterangeComponent;
  rgCreateDateCom!: JkdaterangeComponent;
  rgWC001Com!: JkrangeComponent;
  msWC001Com!: JkmultiselectComponent;
  msStatusCom!: JkmultiselectComponent;
  notConfirmCom!: JkcheckboxComponent;
  msWC006Com!: JkmultiselectComponent;
  msWC005Com!: JkmultiselectComponent;
  cboKindCom!: JkComboboxComponent;

  kindList: idNameItem[] = [];
  kind: string = 'ALL';
  kindListStr: string = `TAXPB81:發票張數檢核,SummaryResult:整合中心回覆上傳結果,
ALL:全部,
C0401:C0401.存證開立發票訊息,C0501:C0501.存證作廢發票,C0701:C0701.存證註銷發票訊息,D0401:D0401.平台存證折讓證明單通知,
B0101:B0101.開立/傳送折讓證明單通知訊息,B0102:B0102.開立/傳送折讓證明單通知接收確認,B0201:B0201.作廢折讓證明單訊息,
B0202:B0202.作廢折讓證明單接收確認訊息,B0401:B0401.存證開立/傳送折讓證明單通知B2B,B0501:B0501.平台存證作廢折讓證明單訊息,
D0501:D0501.存證作廢折讓證明單通知,E0401:E0401.分支機構配號檔,E0402:E0402.空白未使用字軌檔,E0501:E0501.營業人電子發票配號檔(加值中心),
A0101:A0101.開立發票訊息,A0102:A0102.發票接收確認訊息,A0201:A0201.作廢發票訊息,A0202:A0202.作廢發票接收確認訊息,A0301:A0301.退回(拒收)發票訊息,
A0302:A0302.退回發票接收確認訊息,A0401:A0401.平台存證開立發票訊息,A0501:A0501.平台存證作廢發票訊息,A0601:A0601.平台存證退回發票訊息,
E0401:E0401.分支機構配號檔,E0402:E0402.空白未使用字軌檔
`;

  constructor() {
    super();
    this.isCheckPower = false;
    this.setFormOpt2(); //###
    this.kindList = jkLib.colonString2IdNameItem(this.kindListStr, ',');
    this.kind = this.kindList[0].id;
    this.logMessage = '';
    this.gridInitOpt = {
      pageKind: this.pageKind,
      programId: this.programId,
      sortField: '',
      sort: 'asc',
      defaultSort: null,
    };

    //this.addOpenwinLoadOption('#STKME', 'W01', 'W', [], this.stkmeList);
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  override getLookup(): void {
    super.getLookup();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();

  }
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    this.type = 'W';
    this.mainTable = this.programId; //['LG001','LG002','LG003','LG004'];
    this.where = '';
    switch (this.kind) {

      default:
    }

    return true;
  }
  override agRowClicked($event: RowClickedEvent<any, any>) {
    super.agRowClicked($event);
    let r = $event.data;
  }
  doQuery2() {
    this.type = 'S';
    this.mainTable = this.programId; //['LG001','LG002','LG003','LG004'];
    this.where = '';
    switch (this.kind) {
      case 'ALL':
        this.winItem = 'W00';
        //this.// edWC067.addWhere(this.where,'WC067');
        this.where = this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        this.where = this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        this.where = this.msStatusCom.addWhere(this.where, 'WC084');  // ^_^ jackie 20150404    add
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C' `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          if cboStatus.ItemIndex = 7  {             // 空白未回寫
            this.where= this.where + ' AND WC084='''' '
          else
          begin
            mStr= cboStatus.Text;
            mStatus= CutToken(mStr,':');
            this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
         };
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'TAXPB81':
        this.winItem = 'W25';
        this.where = this.where = this.rgWC004Com.addWhere(this.where, 'WR002');
        break;
      case 'A0101': // (1).TAXAB301 A0101 開立發票訊息
        this.winItem = 'W01';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/

        break;
      case 'A0102':   //(2).TAXAB302 A0102 發票接收確認訊息
        this.winItem = 'W02';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // // edWC067.addWhere(this.where,'WC067');
        this.where = this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)    // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'A0201': //(3).TAXAB303 A0201 作廢發票訊息
        this.winItem = 'W03';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)    // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'A0202':  //(4).TAXAB304 A0202 作廢發票接收確認訊息
        this.winItem = 'W04';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'A0301':   //(5).TAXAB305 A0301 退回(拒收)發票訊息
        this.winItem = 'W05';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'A0302': //(6).TAXAB306 A0302 退回發票接收確認訊息->沒寫(預留)
        this.winItem = 'W06';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'A0401':   //(7).TAXAB307 A0401 平台存證開立發票訊息
        this.winItem = 'W07';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'A0501':  //(8).TAXAB308 A0501 平台存證作廢發票訊息
        this.winItem = 'W08';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'A0601':    //(9).TAXAB309 A0601 平台存證退回發票訊息->沒寫(預留)
        this.winItem = 'W09';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'B0101':   //(10).TAXAB310 B0101 開立/傳送折讓證明單通知訊息
        this.winItem = 'W10';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'B0102':   //(11).TAXAB311 B0102 開立/傳送折讓證明單通知接收確認
        this.winItem = 'W11';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'B0201':    //(12).TAXAB312 B0201 作廢折讓證明單訊息->沒寫(預留)
        this.winItem = 'W12';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /* if cboStatus.ItemIndex > 0  {
         begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
        };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'B0202':    //(13).TAXAB313 B0202 作廢折讓證明單接收確認訊息->沒寫(預留)
        this.winItem = 'W13';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'B0401':   //(14).TAXAB314 B0401 平台存證開立/傳送折讓證明單通知->沒寫(預留)
        this.winItem = 'W14';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'B0501':   //(15).TAXAB315 B0501 平台存證作廢折讓證明單訊息->沒寫(預留)
        this.winItem = 'W15';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {
        begin
         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'C0401':   //(16).TAXAB316 C0401 平台存證開立發票訊息
        this.winItem = 'W16';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)    // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /* if cboStatus.ItemIndex > 0  {
         begin
          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
        };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'C0501':    //(17).TAXAB317 C0501 平台存證作廢發票訊息
        this.winItem = 'W17';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {

         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'C0701':    //(18).TAXAB318 C0701 平台存證註銷發票訊息
        this.winItem = 'W18';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {

         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'D0401':    //(19).TAXAB319 D0401 平台存證開立/傳送折讓證明單通知
        this.winItem = 'W19';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /* if cboStatus.ItemIndex > 0  {

          mStr= cboStatus.Text;
          mStatus= CutToken(mStr,':');
          this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
        };
        case cboWC090.ItemIndex of
        1 : this.where= this.where + ' AND WC090=''1'' ';
        2 : this.where= this.where + ' AND WC090=''2'' ';
       };*/
        break;
      case 'D0501':    //(20).TAXAB320 D0501 平台存證作廢折讓證明單通知訊息->沒寫(預留)
        this.winItem = 'W20';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)   // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {

         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'E0401':    //(21).TAXAB321 E0401 分支機構配號檔->沒寫(預留)
        this.winItem = 'W21';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {

         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
      };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'E0402':    //(22).TAXAB322 E0402 空白未使用字軌檔 ->沒寫(預留)
        this.winItem = 'W22';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {

         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'E0501':    //(23).TAXAB323 E0501 營業人電子發票配號檔->沒寫(預留)
        this.winItem = 'W23';
        this.where = this.rgCreateDateCom.addWhere(this.where, 'TAXWC.CREATE_DATE');
        // edWC067.addWhere(this.where,'WC067');
        this.where = this.rgWC001Com.addWhere(this.where, 'WC001');
        this.where = this.msWC001Com.addWhere(this.where, 'WC001');
        this.where = this.rgWC003Com.addWhere(this.where, 'WC003');
        this.where = this.rgWC004Com.addWhere(this.where, 'WC004');
        this.where = this.msWC006Com.addWhere(this.where, 'WC006');
        this.where = this.msWC005Com.addWhere(this.where, 'WC005');
        if (this.notConfirmCom.value)  // ^_^ jackie 20250102 add
          this.where = this.where + ` AND WC084<>'C'  `;
        /*if cboStatus.ItemIndex > 0  {

         mStr= cboStatus.Text;
         mStatus= CutToken(mStr,':');
         this.where= this.where + ' AND WC084='+QuotedStr(mStatus);
       };
       case cboWC090.ItemIndex of
       1 : this.where= this.where + ' AND WC090=''1'' ';
       2 : this.where= this.where + ' AND WC090=''2'' ';
      };*/
        break;
      case 'SummaryResult':    //(24).整合中心回覆上傳結果(SummaryResult)
        this.winItem = 'W24';
        this.where = this.rgWC004Com.addWhere(this.where, 'WP002');
        // / *GROUP* /GROUP BY WP001,WP002,WP004,WF002,MA005,WO002,[產生張數] having [產生張數]<> count(*)

        break;
      default:
    }
    if (this.where === '') {
      alert('至少要有一個選項');
      return;
    }
    const mg = this.masterGrid;
    if (!mg) return;
    mg.doQuery2(this.mainTable, this.winItem, this.type, this.where, this.order, this.params);
    this.masterTabGroupIndex = 1;

  }
  override doComReady($e: any, comName: string) {
    super.doComReady($e, comName);

    if (comName === 'rgWC001') this.rgWC001Com = $e;
    if (comName === 'rgWC003') this.rgWC003Com = $e;
    if (comName === 'kind') this.cboKindCom = $e;
    if (comName === 'rgCreateDate') this.rgCreateDateCom = $e;
    if (comName === 'rgWC004') this.rgWC004Com = $e;
    if (comName === 'msWC001') this.msWC001Com = $e;
    if (comName === 'msWC006') this.msWC006Com = $e;
    if (comName === 'msWC005') this.msWC005Com = $e;
    if (comName === 'notConfirm') this.notConfirmCom = $e;
    if (comName === 'msStatus') this.msStatusCom = $e;


  }

}

